import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { Button } from '@mui/material';

export const Empty = ({ title, buttonTitle, route, onClick }: any) => {
	const { navigateWithLanguage } = useLanguageNavigate();

	return (
		<div className="flex flex-col items-center w-full justify-center gap-8 mt-40">
			<span className="font-roboto font-bold text-[20px] leading-[24px] text-dark">{title}</span>
			<Button
				type="submit"
				variant="contained"
				sx={{ fontWeight: 'bold' }}
				onClick={() => {
					navigateWithLanguage(route);
					onClick?.();
				}}
			>
				{buttonTitle}
			</Button>
		</div>
	);
};
